// PLAY screen markup. The prototype's flat `.play-head` (category chip + "Q1 / 10")
// is now the reference HUD (ui/playHud.ts): ◀ / round pill / ⋯ avatar slot, with a
// 💰 bank · Q3/10 · 🔥 streak strip under it. Every id gameController writes
// (catChip, qProg, meterValue, barFill, hintBtn, questionBody, optionsGrid,
// revealBox, stretchBadge) is still here — the category chip now sits directly
// above the question it labels.
import { playHudHTML } from '../ui/playHud';
import { icon } from '../ui/icons';

export const playHTML = /* html */ `
<div id="screenPlay" class="play hidden">
  ${playHudHTML}
  <!-- ⭐ STRETCH badge (PLAN-gameplay-v2 §3b) — shown only on the round's one
       above-the-cap question; gameController toggles it per serve. -->
  <div class="stretch-badge hidden" id="stretchBadge">${icon('star', 14)} Stretch question. Worth extra, no risk.</div>
  <div class="meter">
    <div class="val money" id="meterValue">$1,000</div>
    <div class="bar-track"><div class="bar-fill" id="barFill"></div></div>
  </div>
  <div class="hint-row"><button class="hint-btn" id="hintBtn" type="button">${icon('bulb', 16)} Theo's 50/50</button></div>
  <div class="hud-catrow"><span class="chip" id="catChip">Category</span></div>
  <div class="qbody" id="questionBody">…</div>
  <div class="options" id="optionsGrid"></div>
  <div class="reveal" id="revealBox"></div>
</div>`;
